import React, { FC, memo } from 'react';
import { useButton } from '~Hooks';
import Icon from '~ComponentsImproved/Icon';
import { GlassPillBase, GlassPillSize, GLASS_PILL_ICON_SIZE } from './styles';

interface Props {
  onClick: () => void;
  /** Optional leading icon, an SVG import. */
  icon?: string;
  size?: GlassPillSize;
  className?: string;
  /** Stable hook for Playwright. */
  testId?: string;
  children: React.ReactNode;
}

/** Tappable glass pill, e.g. "Back" over a hero image or "Start over" in the header. */
const GlassPill: FC<Props> = ({ onClick, icon, size = 'medium', className, testId, children }) => {
  const { touching, disabled, disabledToast, ...button } = useButton({ onClick });

  const classes = [className, touching && 'is-touching'].filter(Boolean).join(' ');

  return (
    <GlassPillBase {...button} size={size} className={classes || undefined} data-testid={testId}>
      {icon && (
        <Icon
          src={icon}
          color="var(--colorWhite)"
          width={GLASS_PILL_ICON_SIZE[size]}
          height={GLASS_PILL_ICON_SIZE[size]}
        />
      )}
      {children}
    </GlassPillBase>
  );
};

export default memo(GlassPill);
